import React from "react";
import AssignOrder from "../../components/AssignOrder";
import { ORDER_TYPE } from "../../enums/order.enum";

const AssignConsultationOrder = () => {
  return <AssignOrder orderType={ORDER_TYPE.CONSULTATION} />;
};

export default AssignConsultationOrder;
